

interface AppSettings {
    APP_Name: string; //--Denumire Aplicatie
    APP_Version: string;//--Versiune Aplicatie
    APP_Color: string;//--Culoarea Aplicatie
    API_Url: string; //--URL API
    API_Url_Comercial: string; //--URL API Comercial
    API_Url_ComercialUpload: string; //--URL API Comercial
    API_Url_Contabilitate: string; //--URL API Contabilitate
    API_Url_ResurseUmane: string; //--URL API Contabilitate
    API_Url_ResurseUmaneOdata: string; //--URL API Contabilitate
    API_Url_ComercialOdata: string; //--URL API Comercial
    API_Url_Documente: string; //--URL API Documente
    API_Url_DocumenteOdata: string; //--URL API Documente
    API_Url_Rapoarte: string; //--URL API Rapoarte
    API_Url_RapoarteOdata: string; //--URL API Rapoarte
    API_Url_ComercialSignalR: string; //--URL API Rapoarte
    API_Url_Anaf: string; //--URL API ANAF
    APP_Timezone: string; //offset-ul de adaugat la data in cazul filtrarilor

}

/**
 * All app params for UI.
 */
const DefaultSetting: AppSettings = {
    APP_Name: 'ERA',
    APP_Version: "26.04.22.1",
    APP_Color: 'red darken-1',

    API_Url: process.env.VUE_APP_API_URL,
    API_Url_Comercial: process.env.VUE_APP_API_URL_COMERCIAL,
    API_Url_ComercialUpload: process.env.VUE_APP_API_URL_COMERCIAL_UPLOAD,
    API_Url_Contabilitate: process.env.VUE_APP_API_URL_CONTABILITATE,
    API_Url_ResurseUmane: process.env.VUE_APP_API_URL_RESURSEUMANE,
    API_Url_ResurseUmaneOdata: process.env.VUE_APP_API_URL_RESURSEUMANE_ODATA,
    API_Url_ComercialOdata: process.env.VUE_APP_API_URL_COMERCIAL_ODATA,
    API_Url_Documente: process.env.VUE_APP_API_URL_DOCUMENTE,
    API_Url_DocumenteOdata: process.env.VUE_APP_API_URL_DOCUMENTE_ODATA,
    API_Url_Rapoarte: process.env.VUE_APP_API_URL_RAPOARTE,
    API_Url_RapoarteOdata: process.env.VUE_APP_API_URL_RAPOARTE_ODATA,
    API_Url_ComercialSignalR: process.env.VUE_APP_API_URL_COMERCIAL_SIGNALR,
    API_Url_Anaf: process.env.VUE_APP_API_URL_COMERCIAL,
    APP_Timezone: '+02:00',
};


export default DefaultSetting








